// src/utils/lightingFormulas.js

/**
 * Tabla de niveles de iluminación requeridos (ISO 8995)
 */
export const LIGHTING_STANDARDS = [
  { area: "Zonas de circulación, pasillos", lux: 100 },
  { area: "Almacenes, depósitos", lux: 200 },
  { area: "Tareas administrativas, oficinas", lux: 500 },
  { area: "Dibujo técnico, diseño, inspección", lux: 750 },
  { area: "Montaje de alta precisión", lux: 1000 }
];

/**
 * Calcula el número de luminarias necesarias usando el método de lúmenes
 * Formula: N = (E * A) / (Phi * Cu * Fm)
 */
// Añadir al cálculo en src/utils/lightingFormulas.js
export const calculateLamps = (params) => {
  const { length, width, targetLux, lumensPerLamp, tubesPerLamp = 1, cu = 0.6, fm = 0.8 } = params;
  
  const area = length * width;
  if (area <= 0 || lumensPerLamp <= 0) return null;

  // Calculamos lúmenes totales de la luminaria (Lúmenes x cantidad de tubos)
  const totalLumensPerFixture = lumensPerLamp * tubesPerLamp;

  const nTotal = (targetLux * area) / (totalLumensPerFixture * cu * fm);
  const roundedN = Math.ceil(nTotal);

  const aspect = length / width;
  const cols = Math.round(Math.sqrt(roundedN / aspect)) || 1;
  const rows = Math.ceil(roundedN / cols) || 1;
  
  const finalN = rows * cols;

  return {
    total: finalN,
    rows,
    cols,
    illuminanceAchieved: ((finalN * totalLumensPerFixture * cu * fm) / area).toFixed(1)
  };
};

// src/utils/lightingFormulas.js

export const FIXTURE_TYPES = {
  bulb: { name: "Bombillo / Spot", ratio: 1, shape: "circle" },
  tube_short: { name: "Tubo Corto (0.60m)", ratio: 4, shape: "rect" },
  tube_long: { name: "Tubo Largo (1.20m)", ratio: 8, shape: "rect" },
  panel: { name: "Panel LED (60x60)", ratio: 2, shape: "square" }
};

export const LIGHT_SOURCES = {
  led: { name: "LED", efficiency: 100 }, // lm/W aprox
  fluorescent: { name: "Fluorescente", efficiency: 60 },
  incandescent: { name: "Incandescente", efficiency: 15 }
};

export const calculateLampsV2 = (params) => {
  const { length, width, targetLux, lumensPerLamp, wattsPerLamp, cu = 0.6, fm = 0.8 } = params;
  const area = length * width;
  
  if (area <= 0 || lumensPerLamp <= 0) return null;

  // 1. Cantidad Mínima (Cálculo teórico puro)
  const nMinRaw = (targetLux * area) / (lumensPerLamp * cu * fm);
  const nMin = Math.ceil(nMinRaw);

  // 2. Cantidad Óptima (Basada en Grid para uniformidad)
  const aspect = length / width;
  const cols = Math.round(Math.sqrt(nMin / aspect)) || 1;
  const rows = Math.ceil(nMin / cols) || 1;
  const nOpt = rows * cols;

  // 3. Cálculos de Salida (Como en la imagen)
  const totalWatts = (nOpt * wattsPerLamp).toFixed(1);
  const totalLumens = nOpt * lumensPerLamp;
  const achievedLux = ((totalLumens * cu * fm) / area).toFixed(1);
  const wattsPerM2 = (totalWatts / area).toFixed(2);

  // 4. Coordenadas para el plano (Ejes X e Y)
  const coordsX = Array.from({ length: cols }).map((_, c) => (width / (cols * 2)) * (2 * c + 1));
  const coordsY = Array.from({ length: rows }).map((_, r) => (length / (rows * 2)) * (2 * r + 1));

  return {
    min: nMin,
    optimal: nOpt,
    rows,
    cols,
    achievedLux,
    wattsPerM2,
    totalLumens,
    totalWatts,
    coordsX,
    coordsY
  };
};
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/